import { useTranslation } from "react-i18next";
import { LandingNavbar } from "@/components/landing/LandingNavbar";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";

export default function Imprint() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <LandingNavbar />
      <main className="pt-24 pb-16 px-4 max-w-3xl mx-auto">
        <Button variant="ghost" size="sm" asChild className="mb-6">
          <Link to="/landing">
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t("common.back")}
          </Link>
        </Button>

        <h1 className="text-3xl font-bold mb-8">{t("legal.imprint.title")}</h1>

        <div className="space-y-6 text-muted-foreground">
          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.imprint.companyInfo")}
            </h2>
            <p>
              {/* TODO: Echte Firmendaten eintragen */}
              CheckMaty GmbH
              <br />
              Musterstraße 1<br />
              12345 Musterstadt
              <br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.imprint.contact")}
            </h2>
            <p>
              {/* TODO: Echte Kontaktdaten eintragen */}
              E-Mail: info@checkmaty.com
              <br />
              Telefon: +49 (0) 123 456 789
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.imprint.represented")}
            </h2>
            <p>
              {/* TODO: Echte Geschäftsführer eintragen */}
              Max Mustermann, Geschäftsführer
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.imprint.registration")}
            </h2>
            <p>
              {/* TODO: Echte Registerdaten eintragen */}
              Handelsregister: Amtsgericht Musterstadt
              <br />
              HRB 12345
              <br />
              USt-IdNr.: DE123456789
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.imprint.responsibility")}
            </h2>
            <p>
              {/* TODO: Echte Daten eintragen */}
              Max Mustermann
              <br />
              Musterstraße 1<br />
              12345 Musterstadt
            </p>
          </section>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
}
